module.exports = __webpack_public_path__ + "975e96623fd5a30a2353d11b3da7ead5.png";


//////////////////
// WEBPACK FOOTER
// ./ClientApp/img/logo-dark.png
// module id = 346
// module chunks = 0